import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import HelpIconButton from "../../Components/Buttons/Iconbuttons/HelpIconButton";
import { useId } from "react";

export default function FormSelectField({
  valuesArray,
  fieldLabel,
  fieldState,
  helperText,
  modalTitle,
  onChange,
  modalDescription,
  isDisabled = false,
  modalOff = false,
  errorFound = false,
}) {
  const fieldId = useId();

  return (
    <div className="mb-4 flex w-full items-start gap-2">
      <TextField
        error={errorFound}
        disabled={isDisabled}
        id={fieldId}
        select
        size="small"
        sx={{ width: "100%", maxWidth: "320px" }}
        label={fieldLabel}
        value={fieldState ?? ""}
        helperText={helperText}
        onChange={onChange}
      >
        {valuesArray.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>

      {!modalOff && (
        <div className="mt-1">
          <HelpIconButton title={modalTitle} description={modalDescription} />
        </div>
      )}
    </div>
  );
}
